import { Language } from '../utils/i18nHelpers';

export const SITE_CONTACT = {
  email: 'contact@devalpha1.com',
  phone: '+375257279660',
  phoneDisplay: '+375 25 727-96-60',
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Minsk,+Belarus',
  location: {
    fr: 'Minsk, Biélorussie',
    en: 'Minsk, Belarus',
    ru: 'Минск, Беларусь',
  } satisfies Record<Language, string>,
  addressLine: {
    fr: 'Minsk, Biélorussie',
    en: 'Minsk, Belarus',
    ru: 'Минск, Беларусь',
  } satisfies Record<Language, string>,
} as const;

export const getSiteLocation = (lang: Language) => SITE_CONTACT.location[lang];
